export const PackMasterColumns = [
    "PackColorCode",
    "Style",
    "ColorCode",
    "NoOfPack",
  ]


  